import logo from './logo.svg';
import './App.css';

import React, { useState, useEffect, useLayoutEffect } from 'react';
import { eventWrapper } from '@testing-library/user-event/dist/utils';
import { CurrencyRupeeIcon } from '@heroicons/react/16/solid';

const App = () => {
  const today = new Date();
  const [currentDay, setCurrentDay] = useState(today.getDate());
  const [selectedMenuType, setSelectedMenuType] = useState(() => {
    // Retrieve the selected menu type from local storage if available
    const storedMenuType = localStorage.getItem('selectedMenuType');
    return storedMenuType ? storedMenuType : "special"; // Default to special menu if not stored
  });
  const [menus, setMenus] = useState({}); // Object to hold all menus

  const currDate = today.getDate();
  const currHour = today.getHours();
  const currMin = today.getMinutes();

  useEffect(() => {
    const storedMenus = localStorage.getItem('menus');
    const storedDate = localStorage.getItem('storedDate');
    if (storedMenus && storedDate === currDate) {
      // If menus are found in local storage, parse and set them
      setMenus(JSON.parse(storedMenus)[selectedMenuType]);
    }

    else {
      const fetchedMenus = {
        veg:
        {
          "1": {
            "breakfast": "Mooli Paratha, Curd,  | Pongal, Chutney, Sambar | B,B,J  Tea, Coffee, Milk,  |  ",
            "lunch": "Phulka, Dal Masala, White Rice,Sambar | Rasam,   Curd,  Onion Rings  | Green Veg Sabzhi (without potatoes)",
            "snacks": "Dahi Papdi Chat/  | Dahi Poori chat |   | Tea,Coffee,Milk",
            "dinner": "Poori,  Channa Masala,   White Rice  | Rasam,  Sambar, Loose Curd  | Jeera Rice, Cabbage Poriyal  |   Fruits : Banana  "
          },
          "2": {
            "breakfast": "Kal Dosa, Vadacurry / Sambar  | Chutney, B,B,J   | Tea, Coffee, Milk  |  ",
            "lunch": "Phulka, Dal Lasoni, White Rice,Sambar | Rasam, Loose  Curd,  Wheel Chips  | Panneer  Makhanwala, Poriyal | Sweet :  Gulab Jamun ",
            "snacks": "Eggless Cake  |   |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal Makhani, White Rice  | Rasam, Sambar, Butter Milk, Chutney  | Idly, Sambar, Beetroot Poriyal |   Fruits :  Seasonal Fruits "
          },
          "3": {
            "breakfast": "Aloo Paratha, Curd,   | Kitchadi, Chutney, Sambar  | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka,Dal Maharani,White Rice,Sambar | Rasam, Karakozhambu/ More Kozhambhu | Poriyal ,Dahi Vada, Fryums ",
            "snacks": "Onion Bajji/ | Onion Pakoda | Sauce  | Tea,Coffee,Milk",
            "dinner": "Phulka, Dhal Rajma, White Rice  | Rasam, Sambar,Curd,  Garlic Sauce  | Veg Fried rice, Thurai Tomato Sabzhi | Fruits :   Water melon "
          },
          "4": {
            "breakfast": "Vada Paav/ Paav Bhaji,  | Pongal, Chutney, Sambar | B,B,J  Tea, Coffee, Milk   |  ",
            "lunch": "Phulka, Dal tadka, White Rice, Sambar | Rasam,Papad,Veg Biryani,  | Panneer Butter masala, Onion Raitha,  | Sweet : Ice Cream ",
            "snacks": "Veg Puffs  | Sauce  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal , White Rice  | Rasam, Sambar,   Loose Curd  | Aloo Gobi Capsicum Masala,  | Papaya"
          },
          "5": {
            "breakfast": "Aloo Paratha, Curd,   | Kitchadi, Chutney, Sambar  | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka,Dal Maharani,White Rice,Sambar | Rasam, Karakozhambu/ More Kozhambhu | Poriyal ,Dahi Vada, Fryums ",
            "snacks": "Onion Bajji/ | Onion Pakoda | Sauce  | Tea,Coffee,Milk",
            "dinner": "Phulka, Dhal Rajma, White Rice  | Rasam, Sambar,Curd,  Garlic Sauce  | Veg Fried rice, Thurai Tomato Sabzhi | Fruits :   Water melon "
          },
          "6": {
            "breakfast": "Vada Paav/ Paav Bhaji,  | Pongal, Chutney, Sambar | B,B,J  Tea, Coffee, Milk   |  ",
            "lunch": "Phulka, Dal tadka, White Rice, Sambar | Rasam,Papad,Veg Biryani,  | Panneer Butter masala, Onion Raitha,  | Sweet : Ice Cream ",
            "snacks": "Veg Puffs  | Sauce  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal , White Rice  | Rasam, Sambar,   Loose Curd  | Aloo Gobi Capsicum Masala,  | Papaya"
          },
          "7": {
            "breakfast": "Poori, Aloo Masala,  | Semiya, Chutney,  | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka, Dal Ajawin, White Rice,Sambar | Rasam,Butter Milk, Onion rings  | Soya Chunk Tikka Masala | Sweet:  Rava Laddu  / Boondhi laddu ",
            "snacks": " Veg Cutlet |   |   | Tea, Coffee, Milk",
            "dinner": "Roti, Dosa, Chutney,Dhal,White Rice  | Rasam, Sambar,   Loose Curd  | Green Veg Sabzhi,  | Fresh Fruits"
          },
          "8": {
            "breakfast": "Idly, Vada, Sambar, Chutney,Kitchadi | B,B,J  Tea, Coffee, Milk  |   |  ",
            "lunch": "Phulka, Dal  Thadka, White Rice,  | Rasam, Loose Curd | Bisibilla Huliyana, Wheel Chips | Mushroom peas Masala",
            "snacks": "Veg Samosa/ |   | Imly sauce  | Tea, Coffee, Milk",
            "dinner": "Chapathi, Dhal ,White Rice ,Rasam |  Sambar, Butter Milk,  Banaras Aloo Baigan  | Thai Veg Fried Rice,  Garlic Sauce  | Hot Badam Milk, Banana"
          },
          "9": {
            "breakfast": "Plain Masala Dosa (Thin),  | Sambar, Chutney | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka, Dal Punjabi, White Rice,Sambar | Rasam, Curd, Fryums | Panneer Do Piaza,   Poriyal  | Sweet : Jangri / Jilebi",
            "snacks": "Pani Poori / | Channa Chat  |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal fry, White Rice  | Rasam, Sambar,   Curd rice  | Meal maker & Capsicum Masala/Bhindhi Masala | Fruits : Water Melon "
          },
          "10": {
            "breakfast": "Aloo Paratha,Curd,Pickle,Rava Upma | Chutney,Sambar  | B,B,J  Tea, Coffee, Milk, ",
            "lunch": "Phulka, Dal Rajma, White Rice, Sambar | Rasam,  Curd, Papad,  Poriyal  | Veg Kholapuri / Veg Shahi Masala |  ",
            "snacks": "Raw Banana Bajji | Coconut Chutney |   | Tea, Coffee, Milk",
            "dinner": "Poori, Channa Masala, White Rice  | Rasam, Sambar,   Loose Curd, Variety rice  | Green Poriyal  | Fruits : Banana "
          },
          "11": {
            "breakfast": " Plain Dosa(THIN), Sambar, Chutney |  B,B,J  Tea, Coffee, Milk  |   |  ",
            "lunch": "Phulka, Dal Rajasthani, White Rice, | Sambar,Rasam, Curd, Masala Papad  | PanneerTikka Masala, Keerai kootu  | Sweet :   Gulab Jamun ",
            "snacks": "Eggless Cake  |   |   | Tea, Coffee, Milk",
            "dinner": "Phulka Idly, Dhal Rajma ,White Rice  | Rasam, Sambar, chutney  Butter Milk  | Fruits :  Seasonal Fruits "
          },
          "12": {
            "breakfast": "Mixed Veg Paratha, Curd,   | Kitchadi, Chutney, Sambar | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka, Dal Thadka, White Rice,  | Rasam, Kadi pakoda / Dahi vada,Papad  | Sambar/Kara Kozhambu,   | Capsicum Peas Masala ",
            "snacks": "Masala Vada | Chutney | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal Masala, White Rice  | Rasam, Sambar, Poriyal, Butter Milk  |  Veg Fried Rice , Gobi Manchurian | Fruits : Papaya "
          },
          "13": {
            "breakfast": "Podi Idly Paav Bhaji, Sambar,Chutney | B,B,J  Tea, Coffee, Milk  |   |  ",
            "lunch": "Phulka, Dal, White Rice,Sambar | Rasam,Curd,  Fryums  | Veg Biryani, Oil Brinjal, Onion Raitha | Sweet : Ice Cream ",
            "snacks": "Channa Chat  | Mint Chutney  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal Thoor, White Rice  | Rasam, Sambar, Butter Milk, Lemon Rice  |  Aloo Capsicum Muttar Masala | Seasonal Fruits "
          },
          "14": {
            "breakfast": "Poori, Aloo Masala,  | Poha Nampkin, Chutney | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka, Dal Fry, White Rice, | Sambar,Rasam, Loose Curd,  | Kadai Panneer,    | Sweet :  Badushai / Coconut Laddu ",
            "snacks": "Masala Peanuts/  | Sundal  |   | Tea,Coffee,Milk",
            "dinner": "Methi roti,Plain Dosa, Sambar, Chuteny,    | Rasam, Sambar,  Butter Milk, Poriyal, White Rice | Channa Masala,    | Fruits :   Musk Melon"
          },
          "15": {
            "breakfast": "Gobi Paratha, Curd,  Pickle  | Kitchadi,Sambar, Chutney | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka, DalThadka, White Rice, | Sambar,  Rasam, Butter Milk, Papad, |  Bisibilla Bath,Veg Jal Frizhi  |  ",
            "snacks": "Onion Samosa | Sauce  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal  fry , White Rice  | Rasam, Sambar,   Curd    | Variety rice, Veg Kuftha curry  |   Fruits :  Fruit Salad "
          },
          "16": {
            "breakfast": "Plain Dosa, Sambar, Chutney  | B,B,J  Tea, Coffee, Milk  |   |  ",
            "lunch": "Ghee Phulka, Dal Fry, White Rice, | Sambar,Rasam, Curd,  Fryums, | Veg Hydrabadi | Gova Jangri",
            "snacks": " Onion Pakoda  | Chutney  |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal Thadka , White Rice  | Rasam, Sambar,  Butter Milk  | Puliyodra, Aloo Podimas, Bindi masala | Fruits : Water Melon "
          },
          "17": {
            "breakfast": "Mooli Paratha, Curd,  | Pongal, Chutney, Sambar | B,B,J  Tea, Coffee, Milk,  |  ",
            "lunch": "Phulka, Dal Masala, White Rice,Sambar | Rasam,   Curd,  Onion Rings  | Green Veg Sabzhi (without potatoes)",
            "snacks": "Dahi Papdi Chat/  | Dahi Poori chat |   | Tea,Coffee,Milk",
            "dinner": "Poori,  Channa Masala,   White Rice  | Rasam,  Sambar, Loose Curd  | Jeera Rice, Cabbage Poriyal  |   Fruits : Banana  "
          },
          "18": {
            "breakfast": "Kal Dosa, Vadacurry / Sambar  | Chutney, B,B,J   | Tea, Coffee, Milk  |  ",
            "lunch": "Phulka, Dal Lasoni, White Rice,Sambar | Rasam, Loose  Curd,  Wheel Chips  | Panneer  Makhanwala, Poriyal | Sweet :  Gulab Jamun ",
            "snacks": "Eggless Cake  |   |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal Makhani, White Rice  | Rasam, Sambar, Butter Milk, Chutney  | Idly, Sambar, Beetroot Poriyal |   Fruits :  Seasonal Fruits "
          },
          "19": {
            "breakfast": "Aloo Paratha, Curd,   | Kitchadi, Chutney, Sambar  | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka,Dal Maharani,White Rice,Sambar | Rasam, Karakozhambu/ More Kozhambhu | Poriyal ,Dahi Vada, Fryums ",
            "snacks": "Onion Bajji/ | Onion Pakoda | Sauce  | Tea,Coffee,Milk",
            "dinner": "Phulka, Dhal Rajma, White Rice  | Rasam, Sambar,Curd,  Garlic Sauce  | Veg Fried rice, Thurai Tomato Sabzhi | Fruits :   Water melon "
          },
          "20": {
            "breakfast": "Vada Paav/ Paav Bhaji,  | Pongal, Chutney, Sambar | B,B,J  Tea, Coffee, Milk   |  ",
            "lunch": "Phulka, Dal tadka, White Rice, Sambar | Rasam,Papad,Veg Biryani,  | Panneer Butter masala, Onion Raitha,  | Sweet : Ice Cream ",
            "snacks": "Veg Puffs  | Sauce  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal , White Rice  | Rasam, Sambar,   Loose Curd  | Aloo Gobi Capsicum Masala,  | Papaya"
          },
          "21": {
            "breakfast": "Poori, Aloo Masala,  | Semiya, Chutney,  | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka, Dal Ajawin, White Rice,Sambar | Rasam,Butter Milk, Onion rings  | Soya Chunk Tikka Masala | Sweet:  Rava Laddu  / Boondhi laddu ",
            "snacks": " Veg Cutlet |   |   | Tea, Coffee, Milk",
            "dinner": "Roti, Dosa, Chutney,Dhal,White Rice  | Rasam, Sambar,   Loose Curd  | Green Veg Sabzhi,  | Fresh Fruits"
          },
          "22": {
            "breakfast": "Idly, Vada, Sambar, Chutney,Kitchadi | B,B,J  Tea, Coffee, Milk  |   |  ",
            "lunch": "Phulka, Dal  Thadka, White Rice,  | Rasam, Loose Curd | Bisibilla Huliyana, Wheel Chips | Mushroom peas Masala",
            "snacks": "Veg Samosa/ |   | Imly sauce  | Tea, Coffee, Milk",
            "dinner": "Chapathi, Dhal ,White Rice ,Rasam |  Sambar, Butter Milk,  Banaras Aloo Baigan  | Thai Veg Fried Rice,  Garlic Sauce  | Hot Badam Milk, Banana"
          },
          "23": {
            "breakfast": "Plain Masala Dosa (Thin),  | Sambar, Chutney | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka, Dal Punjabi, White Rice,Sambar | Rasam, Curd, Fryums | Panneer Do Piaza,   Poriyal  | Sweet : Jangri / Jilebi",
            "snacks": "Pani Poori / | Channa Chat  |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal fry, White Rice  | Rasam, Sambar,   Curd rice  | Meal maker & Capsicum Masala/Bhindhi Masala | Fruits : Water Melon "
          },
          "24": {
            "breakfast": "Aloo Paratha,Curd,Pickle,Rava Upma | Chutney,Sambar  | B,B,J  Tea, Coffee, Milk, ",
            "lunch": "Phulka, Dal Rajma, White Rice, Sambar | Rasam,  Curd, Papad,  Poriyal  | Veg Kholapuri / Veg Shahi Masala |  ",
            "snacks": "Raw Banana Bajji | Coconut Chutney |   | Tea, Coffee, Milk",
            "dinner": "Poori, Channa Masala, White Rice  | Rasam, Sambar,   Loose Curd, Variety rice  | Green Poriyal  | Fruits : Banana "
          },
          "25": {
            "breakfast": " Plain Dosa(THIN), Sambar, Chutney |  B,B,J  Tea, Coffee, Milk  |   |  ",
            "lunch": "Phulka, Dal Rajasthani, White Rice, | Sambar,Rasam, Curd, Masala Papad  | PanneerTikka Masala, Keerai kootu  | Sweet :   Gulab Jamun ",
            "snacks": "Eggless Cake  |   |   | Tea, Coffee, Milk",
            "dinner": "Phulka Idly, Dhal Rajma ,White Rice  | Rasam, Sambar, chutney  Butter Milk  | Fruits :  Seasonal Fruits "
          },
          "26": {
            "breakfast": "Mixed Veg Paratha, Curd,   | Kitchadi, Chutney, Sambar | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka, Dal Thadka, White Rice,  | Rasam, Kadi pakoda / Dahi vada,Papad  | Sambar/Kara Kozhambu,   | Capsicum Peas Masala ",
            "snacks": "Masala Vada | Chutney | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal Masala, White Rice  | Rasam, Sambar, Poriyal, Butter Milk  |  Veg Fried Rice , Gobi Manchurian | Fruits : Papaya "
          },
          "27": {
            "breakfast": "Podi Idly Paav Bhaji, Sambar,Chutney | B,B,J  Tea, Coffee, Milk  |   |  ",
            "lunch": "Phulka, Dal, White Rice,Sambar | Rasam,Curd,  Fryums  | Veg Biryani, Oil Brinjal, Onion Raitha | Sweet : Ice Cream ",
            "snacks": "Channa Chat  | Mint Chutney  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal Thoor, White Rice  | Rasam, Sambar, Butter Milk, Lemon Rice  |  Aloo Capsicum Muttar Masala | Seasonal Fruits "
          },
          "28": {
            "breakfast": "Poori, Aloo Masala,  | Poha Nampkin, Chutney | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka, Dal Fry, White Rice, | Sambar,Rasam, Loose Curd,  | Kadai Panneer,    | Sweet :  Badushai / Coconut Laddu ",
            "snacks": "Masala Peanuts/  | Sundal  |   | Tea,Coffee,Milk",
            "dinner": "Methi roti,Plain Dosa, Sambar, Chuteny,    | Rasam, Sambar,  Butter Milk, Poriyal, White Rice | Channa Masala,    | Fruits :   Musk Melon"
          },
          "29": {
            "breakfast": "Gobi Paratha, Curd,  Pickle  | Kitchadi,Sambar, Chutney | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka, DalThadka, White Rice, | Sambar,  Rasam, Butter Milk, Papad, |  Bisibilla Bath,Veg Jal Frizhi  |  ",
            "snacks": "Onion Samosa | Sauce  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal  fry , White Rice  | Rasam, Sambar,   Curd    | Variety rice, Veg Kuftha curry  |   Fruits :  Fruit Salad "
          },
          "30": {
            "breakfast": "Plain Dosa, Sambar, Chutney  | B,B,J  Tea, Coffee, Milk  |   |  ",
            "lunch": "Ghee Phulka, Dal Fry, White Rice, | Sambar,Rasam, Curd,  Fryums, | Veg Hydrabadi | Gova Jangri",
            "snacks": " Onion Pakoda  | Chutney  |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal Thadka , White Rice  | Rasam, Sambar,  Butter Milk  | Puliyodra, Aloo Podimas, Bindi masala | Fruits : Water Melon "
          },
          "31": {
            "breakfast": "Plain Masala Dosa (Thin),  | Sambar, Chutney | B,B,J  Tea, Coffee, Milk  |  ",
            "lunch": "Phulka, Dal Punjabi, White Rice,Sambar | Rasam, Curd, Fryums | Panneer Do Piaza,   Poriyal  | Sweet : Jangri / Jilebi",
            "snacks": "Pani Poori / | Channa Chat  |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal fry, White Rice  | Rasam, Sambar,   Curd rice  | Meal maker & Capsicum Masala/Bhindhi Masala | Fruits : Water Melon "
          },

        },

        nonVeg:
        {

          "1": {
            "breakfast": "Mooli  Paratha,Curd,  Pongal, Chutney | Sambar | B,B,J  Tea, Coffee, Milk, | Fried Egg Masala ( 2 nos ) ",
            "lunch": "Phulka, Dal Masala, White Rice,Sambar | Rasam,  Butter Milk, Onion Rings  | Green Veg Sabzhi ( no potatoes)",
            "snacks": "Dahi Papdi Chat/  | Dahi Poori chat |   | Tea,Coffee,Milk",
            "dinner": "Poori,  Channa Masala, White Rice  | Rasam,  Sambar, Loose Curd  | Jeera Rice, Poriyal  | Fruits : Banana  "
          },
          "2": {
            "breakfast": "Kal Dosa, Vadacurry, Chutney  | B,B,J  Tea, Coffee, Milk  |   | Egg Burji ( 2 nos ) ",
            "lunch": "Phulka, Dal Lasoni, White Rice,Sambar | Rasam,   Loose Curd ,  Wheel Chips  | Chicken 65 / Chicken Tikka Masala,  | Avarakkai Poriyal,Sweet:Gulab Jamun ",
            "snacks": "Cream Cake  |   |   | Tea, Coffee, Milk",
            "dinner": "Phulka,Dhal Makhani,White Rice  | Rasam,Sambar,Butter Milk,Chutney | Idly,Sambar,Beetroot Poriyal | Fruits:Seasonal Fruits "
          },
          "3": {
            "breakfast": "Aloo Paratha, Curd,   | Kitchadi, Chutney, Sambar  | B,B,J  Tea, Coffee, Milk  | Fried Egg ( 2 nos ) ",
            "lunch": "Phulka,Dal Maharani,White Rice,Sambar | Rasam,Kara/Morekozhambu,Poriyal  | Dahi Vada, Fryums ",
            "snacks": "Onion Bajji/ | Onion Pakoda | Sauce  | Tea,Coffee,Milk",
            "dinner": "Phulka, Dhal Rajma, White Rice  | Rasam, Sambar,Curd,  Garlic Sauce  | Egg  Fried rice, Thurai Tomato Sabzhi | Fruits :   Water melon "
          },
          "4": {
            "breakfast": "Vada Paav/ Paav Bhaji,  Pongal | Sambar, Chutney  | B,B,J  Tea, Coffee, Milk, | Egg Burji ( 2 nos ) ",
            "lunch": "Phulka, Dal tadka, White Rice,Sambar | Rasam, Papad, Onion Raitha | Chicken Biryani, BanarasBaigan,  | Sweet : Ice Cream ",
            "snacks": "Veg Puffs  | Sauce  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal , White Rice  | Rasam, Sambar,  Butter Milk  | Aloo Gobi  Capsicum  Masala,  | Papaya"
          },
          "5": {
            "breakfast": "Aloo Paratha, Curd,   | Kitchadi, Chutney, Sambar  | B,B,J  Tea, Coffee, Milk  | Fried Egg ( 2 nos ) ",
            "lunch": "Phulka,Dal Maharani,White Rice,Sambar | Rasam,Kara/Morekozhambu,Poriyal  | Dahi Vada, Fryums ",
            "snacks": "Onion Bajji/ | Onion Pakoda | Sauce  | Tea,Coffee,Milk",
            "dinner": "Phulka, Dhal Rajma, White Rice  | Rasam, Sambar,Curd,  Garlic Sauce  | Egg  Fried rice, Thurai Tomato Sabzhi | Fruits :   Water melon "
          },
          "6": {
            "breakfast": "Vada Paav/ Paav Bhaji,  Pongal | Sambar, Chutney  | B,B,J  Tea, Coffee, Milk, | Egg Burji ( 2 nos ) ",
            "lunch": "Phulka, Dal tadka, White Rice,Sambar | Rasam, Papad, Onion Raitha | Chicken Biryani, BanarasBaigan,  | Sweet : Ice Cream ",
            "snacks": "Veg Puffs  | Sauce  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal , White Rice  | Rasam, Sambar,  Butter Milk  | Aloo Gobi  Capsicum  Masala,  | Papaya"
          },
          "7": {
            "breakfast": "Poori,Aloo Masala,Semiya,Chutney |   | B,B,J  Tea, Coffee, Milk  |  French Toast ",
            "lunch": "Phulka, Dal Ajawin, White Rice,Sambar | Rasam,  Curd,  Onion rings  | Egg Masala,  Poriyal  | Sweet:  Rava Laddu  / Boondhi laddu ",
            "snacks": " Veg Cutlet |   |   | Tea, Coffee, Milk",
            "dinner": "Roti, Dosa, Chutney,Dhal,White Rice  | Rasam, Sambar,  Butter Milk  | Green Veg Sabzhi,  | Fresh Fruits"
          },
          "8": {
            "breakfast": "Idly,Vada,Sambar,Chutney,Kitchadi  | B,B,J  Tea, Coffee, Milk  |   | Fried Eggs ( 2 nos)",
            "lunch": "Phulka, Dal  Thadka, White Rice,  | Rasam,  Loose Curd | Bisibilla Huliyana, Wheel Chips | Mushroom peas Masala",
            "snacks": "Veg Samosa/ |   | Imly sauce  | Tea, Coffee, Milk",
            "dinner": "Chapathi,Dhal,White Rice,Rasam |  Sambar,Butter Milk,Banaras Aloo Baigan  | Egg Thai Fried Rice, Garlic Sauce  | Hot Badam Milk, Banana"
          },
          "9": {
            "breakfast": "Plain Masala Dosa (Thin),  | Sambar, Chutney |  B,B,J  Tea, Coffee, Milk  | Fried Boiled Egg ( 2 nos ) ",
            "lunch": "Phulka, Dal Lasoni, White Rice,Sambar | Rasam,  Curd,  Fryums | Chicken  Do Piazha,   Poriyal  | Sweet : Jangri / Jilebi",
            "snacks": "Pani Poori / | Channa Chat  |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal fry, White Rice  | Rasam, Sambar,   Curd rice  | Meal maker peas & capsicum masala | Fruits : Water Melon "
          },
          "10": {
            "breakfast": "Aloo Paratha,Curd,Pickle,Rava upma,   | Chutney,Sambar  | B,B,J  Tea, Coffee, Milk, | Scrambeled Egg ( 2 nos ) ",
            "lunch": "Phulka, Dal Rajma, White Rice, Sambar | Rasam,  Curd, Papad,   Poriyal  | Veg Kholapuri / Veg Shahi Masala |  ",
            "snacks": "Raw Banana Bajji | Coconut Chutney |   | Tea, Coffee, Milk",
            "dinner": "Poori, Channa Masala, White Rice  | Rasam, Sambar,  Loose Curd, Variety rice  |   Green Poriyal  |   Fruits : Banana "
          },
          "11": {
            "breakfast": " Plain Dosa ( THIN), Sambar, Chutney |  B,B,J  Tea, Coffee, Milk  |   | Boiled Fried Eggs ( 2 nos ) ",
            "lunch": "Phulka, Dal Rajasthani,White Rice, | Sambar, Rasam, Curd,  Masala Papad  | Chicken 65,  Keerai Kootu  | Sweet :   Gulab Jamun ",
            "snacks": "Cake  |   |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Idly, Dhal Rajma ,White Rice  | Rasam, Sambar, chutney, Butter Milk  | Fruits :  Seasonal Fruits "
          },
          "12": {
            "breakfast": "Mixed Veg  Paratha, Curd,   | Kitchadi,  Chutney, Sambar | B,B,J  Tea, Coffee, Milk  | Egg Burji ( 2 nos ) ",
            "lunch": "Phulka, Dal Thadka, White Rice,  | Rasam, Dahi vada / Kadi Pakoda, Papad  | Capsicum Peas Masala,  Sambar/ | Kara Kozhambu",
            "snacks": "Masala Vada | Chutney | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal Masala, White Rice  | Rasam, Sambar, Poriyal, Butter Milk  |  Egg Fried Rice, Gobi Manchurian | Fruits : Papaya "
          },
          "13": {
            "breakfast": "Podi Idly,Paav Bhaji, Sambar,Chutney | B,B,J  Tea, Coffee, Milk  |   | Omelette ( 2 nos ) ",
            "lunch": "Phulka, Dal, White Rice,Sambar | Rasam,  Fryums, Onion Raitha | Chicken Biryani, Oil Brinjal,  | Sweet : Ice Cream ",
            "snacks": "Channa Chat  | Mint Chutney  | Tea, Coffee, Milk",
            "dinner": "Chapathi, Dhal Thoor, White Rice  | Rasam, Sambar,Butter Milk, Lemon rice | Aloo Capsicum Peas  Masala  | Seasonal Fruits "
          },
          "14": {
            "breakfast": "Poori, Aloo Masala, Poha Nampkin | B,B,J  Tea, Coffee, Milk , Chutney |   | Masala Omelette",
            "lunch": "Phulka,Dal fry,White Rice, | Sambar,Rasam,Loose Curd,Onion Rings  | Kadai Chicken,  Poriyal  | Sweet :  Badushai / Coconut Laddu ",
            "snacks": "Masala Peanuts/  | Sundal  |   | Tea,Coffee,Milk",
            "dinner": "Pudhina Roti,Plain Dosa,Sambar,Chutney | Rasam,Butter Milk,Poriyal  | Channa Masala,   | Fruits :  Musk melon"
          },
          "15": {
            "breakfast": "Gobi Paratha, Curd,  Kitchadi,Sambar | B,B,J  Tea, Coffee, Milk , Pickle  |   | Boiled Egg Masala Dry( 2 nos ) ",
            "lunch": "Phulka, DalThadka, White Rice,Sambar | Rasam,Butter Milk,Papad,Bisibilla Bath | Veg Jal Frizhi  |  ",
            "snacks": "Onion Samosa | Sauce  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal  fry , White Rice  | Rasam, Sambar,   Curd    | Variety rice, Veg Kuftha curry  |   Fruits :  Fruit Salad "
          },
          "16": {
            "breakfast": "Plain Dosa, Sambar, Chutney  | B,B,J  Tea, Coffee, Milk  |   | Scrambeled Egg ( 2 nos ) ",
            "lunch": "Phulka, Dal Fry, White Rice,Sambar | Rasam,  Butter Milk,  Fryums, Poriyal, | Chicken  Hydrabadi | Gova Jangri",
            "snacks": " Onion Pakoda  | Chutney  |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal thadka , White Rice  | Rasam, Sambar,  Butter Milk  | Puliyodra, Aloo Podimas, Bindi masala | Fruits : Water Melon "
          },
          "17": {
            "breakfast": "Mooli  Paratha,Curd,  Pongal, Chutney | Sambar | B,B,J  Tea, Coffee, Milk, | Fried Egg Masala ( 2 nos ) ",
            "lunch": "Phulka, Dal Masala, White Rice,Sambar | Rasam,  Butter Milk, Onion Rings  | Green Veg Sabzhi ( no potatoes)",
            "snacks": "Dahi Papdi Chat/  | Dahi Poori chat |   | Tea,Coffee,Milk",
            "dinner": "Poori,  Channa Masala, White Rice  | Rasam,  Sambar, Loose Curd  | Jeera Rice, Poriyal  | Fruits : Banana  "
          },
          "18": {
            "breakfast": "Kal Dosa, Vadacurry, Chutney  | B,B,J  Tea, Coffee, Milk  |   | Egg Burji ( 2 nos ) ",
            "lunch": "Phulka, Dal Lasoni, White Rice,Sambar | Rasam,   Loose Curd ,  Wheel Chips  | Chicken 65 / Chicken Tikka Masala,  | Avarakkai Poriyal,Sweet:Gulab Jamun ",
            "snacks": "Cream Cake  |   |   | Tea, Coffee, Milk",
            "dinner": "Phulka,Dhal Makhani,White Rice  | Rasam,Sambar,Butter Milk,Chutney | Idly,Sambar,Beetroot Poriyal | Fruits:Seasonal Fruits "
          },
          "19": {
            "breakfast": "Aloo Paratha, Curd,   | Kitchadi, Chutney, Sambar  | B,B,J  Tea, Coffee, Milk  | Fried Egg ( 2 nos ) ",
            "lunch": "Phulka,Dal Maharani,White Rice,Sambar | Rasam,Kara/Morekozhambu,Poriyal  | Dahi Vada, Fryums ",
            "snacks": "Onion Bajji/ | Onion Pakoda | Sauce  | Tea,Coffee,Milk",
            "dinner": "Phulka, Dhal Rajma, White Rice  | Rasam, Sambar,Curd,  Garlic Sauce  | Egg  Fried rice, Thurai Tomato Sabzhi | Fruits :   Water melon "
          },
          "20": {
            "breakfast": "Vada Paav/ Paav Bhaji,  Pongal | Sambar, Chutney  | B,B,J  Tea, Coffee, Milk, | Egg Burji ( 2 nos ) ",
            "lunch": "Phulka, Dal tadka, White Rice,Sambar | Rasam, Papad, Onion Raitha | Chicken Biryani, BanarasBaigan,  | Sweet : Ice Cream ",
            "snacks": "Veg Puffs  | Sauce  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal , White Rice  | Rasam, Sambar,  Butter Milk  | Aloo Gobi  Capsicum  Masala,  | Papaya"
          },
          "21": {
            "breakfast": "Poori,Aloo Masala,Semiya,Chutney |   | B,B,J  Tea, Coffee, Milk  |  French Toast ",
            "lunch": "Phulka, Dal Ajawin, White Rice,Sambar | Rasam,  Curd,  Onion rings  | Egg Masala,  Poriyal  | Sweet:  Rava Laddu  / Boondhi laddu ",
            "snacks": " Veg Cutlet |   |   | Tea, Coffee, Milk",
            "dinner": "Roti, Dosa, Chutney,Dhal,White Rice  | Rasam, Sambar,  Butter Milk  | Green Veg Sabzhi,  | Fresh Fruits"
          },
          "22": {
            "breakfast": "Idly,Vada,Sambar,Chutney,Kitchadi  | B,B,J  Tea, Coffee, Milk  |   | Fried Eggs ( 2 nos)",
            "lunch": "Phulka, Dal  Thadka, White Rice,  | Rasam,  Loose Curd | Bisibilla Huliyana, Wheel Chips | Mushroom peas Masala",
            "snacks": "Veg Samosa/ |   | Imly sauce  | Tea, Coffee, Milk",
            "dinner": "Chapathi,Dhal,White Rice,Rasam |  Sambar,Butter Milk,Banaras Aloo Baigan  | Egg Thai Fried Rice, Garlic Sauce  | Hot Badam Milk, Banana"
          },
          "23": {
            "breakfast": "Plain Masala Dosa (Thin),  | Sambar, Chutney |  B,B,J  Tea, Coffee, Milk  | Fried Boiled Egg ( 2 nos ) ",
            "lunch": "Phulka, Dal Lasoni, White Rice,Sambar | Rasam,  Curd,  Fryums | Chicken  Do Piazha,   Poriyal  | Sweet : Jangri / Jilebi",
            "snacks": "Pani Poori / | Channa Chat  |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal fry, White Rice  | Rasam, Sambar,   Curd rice  | Meal maker peas & capsicum masala | Fruits : Water Melon "
          },
          "24": {
            "breakfast": "Aloo Paratha,Curd,Pickle,Rava upma,   | Chutney,Sambar  | B,B,J  Tea, Coffee, Milk, | Scrambeled Egg ( 2 nos ) ",
            "lunch": "Phulka, Dal Rajma, White Rice, Sambar | Rasam,  Curd, Papad,   Poriyal  | Veg Kholapuri / Veg Shahi Masala |  ",
            "snacks": "Raw Banana Bajji | Coconut Chutney |   | Tea, Coffee, Milk",
            "dinner": "Poori, Channa Masala, White Rice  | Rasam, Sambar,  Loose Curd, Variety rice  |   Green Poriyal  |   Fruits : Banana "
          },
          "25": {
            "breakfast": " Plain Dosa ( THIN), Sambar, Chutney |  B,B,J  Tea, Coffee, Milk  |   | Boiled Fried Eggs ( 2 nos ) ",
            "lunch": "Phulka, Dal Rajasthani,White Rice, | Sambar, Rasam, Curd,  Masala Papad  | Chicken 65,  Keerai Kootu  | Sweet :   Gulab Jamun ",
            "snacks": "Cake  |   |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Idly, Dhal Rajma ,White Rice  | Rasam, Sambar, chutney, Butter Milk  | Fruits :  Seasonal Fruits "
          },
          "26": {
            "breakfast": "Mixed Veg  Paratha, Curd,   | Kitchadi,  Chutney, Sambar | B,B,J  Tea, Coffee, Milk  | Egg Burji ( 2 nos ) ",
            "lunch": "Phulka, Dal Thadka, White Rice,  | Rasam, Dahi vada / Kadi Pakoda, Papad  | Capsicum Peas Masala,  Sambar/ | Kara Kozhambu",
            "snacks": "Masala Vada | Chutney | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal Masala, White Rice  | Rasam, Sambar, Poriyal, Butter Milk  |  Egg Fried Rice, Gobi Manchurian | Fruits : Papaya "
          },
          "27": {
            "breakfast": "Podi Idly,Paav Bhaji, Sambar,Chutney | B,B,J  Tea, Coffee, Milk  |   | Omelette ( 2 nos ) ",
            "lunch": "Phulka, Dal, White Rice,Sambar | Rasam,  Fryums, Onion Raitha | Chicken Biryani, Oil Brinjal,  | Sweet : Ice Cream ",
            "snacks": "Channa Chat  | Mint Chutney  | Tea, Coffee, Milk",
            "dinner": "Chapathi, Dhal Thoor, White Rice  | Rasam, Sambar,Butter Milk, Lemon rice | Aloo Capsicum Peas  Masala  | Seasonal Fruits "
          },
          "28": {
            "breakfast": "Poori, Aloo Masala, Poha Nampkin | B,B,J  Tea, Coffee, Milk , Chutney |   | Masala Omelette",
            "lunch": "Phulka,Dal fry,White Rice, | Sambar,Rasam,Loose Curd,Onion Rings  | Kadai Chicken,  Poriyal  | Sweet :  Badushai / Coconut Laddu ",
            "snacks": "Masala Peanuts/  | Sundal  |   | Tea,Coffee,Milk",
            "dinner": "Pudhina Roti,Plain Dosa,Sambar,Chutney | Rasam,Butter Milk,Poriyal  | Channa Masala,   | Fruits :  Musk melon"
          },
          "29": {
            "breakfast": "Gobi Paratha, Curd,  Kitchadi,Sambar | B,B,J  Tea, Coffee, Milk , Pickle  |   | Boiled Egg Masala Dry( 2 nos ) ",
            "lunch": "Phulka, DalThadka, White Rice,Sambar | Rasam,Butter Milk,Papad,Bisibilla Bath | Veg Jal Frizhi  |  ",
            "snacks": "Onion Samosa | Sauce  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal  fry , White Rice  | Rasam, Sambar,   Curd    | Variety rice, Veg Kuftha curry  |   Fruits :  Fruit Salad "
          },
          "30": {
            "breakfast": "Plain Dosa, Sambar, Chutney  | B,B,J  Tea, Coffee, Milk  |   | Scrambeled Egg ( 2 nos ) ",
            "lunch": "Phulka, Dal Fry, White Rice,Sambar | Rasam,  Butter Milk,  Fryums, Poriyal, | Chicken  Hydrabadi | Gova Jangri",
            "snacks": " Onion Pakoda  | Chutney  |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal thadka , White Rice  | Rasam, Sambar,  Butter Milk  | Puliyodra, Aloo Podimas, Bindi masala | Fruits : Water Melon "
          },
          "31": {
            "breakfast": "Plain Masala Dosa (Thin),  | Sambar, Chutney |  B,B,J  Tea, Coffee, Milk  | Fried Boiled Egg ( 2 nos ) ",
            "lunch": "Phulka, Dal Lasoni, White Rice,Sambar | Rasam,  Curd,  Fryums | Chicken  Do Piazha,   Poriyal  | Sweet : Jangri / Jilebi",
            "snacks": "Pani Poori / | Channa Chat  |   | Tea, Coffee, Milk",
            "dinner": "Phulka, Dhal fry, White Rice  | Rasam, Sambar,   Curd rice  | Meal maker peas & capsicum masala | Fruits : Water Melon "
          },
        },
        special:
        {
          "1": {
            "breakfast": " Panneer Paratha,  Pongal, Vada, Sambar | Fresh Juice,Cold Milk,Cornflakes,Chutney  | B,B,J Tea, Coffee, Milk  | Black Channa Sprout,Boiled Eggs(2 nos) ",
            "lunch": " Phulka, Malabar Fish Curry/Masala Fried Fish  | Nargesi Kuftha Curry, White Rice, Sambar,  | Wheel Chips, Dal Fry,  Butter Milk,Rasam  | Sweet:Rasmalai/ Rasagula  ",
            "snacks": "Spring roll | Sauce  |   | Tea, Coffee, Milk ",
            "dinner": "Poori, Channa Masala ,White Rice, Rasam | Vaangi Baath, Poriyal  | Curd   | Cr. Of  Brocoli Soup,  Fruit Salad "
          },
          "2": {
            "breakfast": "Kal Dosa, Vada Curry, Chutney,   | Fresh  Juice, Cold Milk, Cornflakes  | B,B,J Tea, Coffee, Milk  | Moong Dal Sprout,  Scrambeled Egg(2)",
            "lunch": "Phulka,Dhal,Tandoori Chicken,Panneer Fingers | White rice,Sambar,Gr.Veg Sabzhi(without potato) | Curd,Fryums, Pineapple Rasam  | Sweet:Gulab Jamun / Makhan peda ",
            "snacks": "Brownie Cake/ |   | Hot Badam Milk | Tea, Coffee, Milk ",
            "dinner": "Phulka, Dal Makhani,Idly, Sambar, Chutney  | White Rice,Dhum Aloo/Banaras Aloo, | White rice,Rasam, Loose Curd,   | Cream of Tomato, Fruits :  Fresh Fruits "
          },
          "3": {
            "breakfast": "Aloo Paratha, Curd, Kitchadi, Chutney   | Fresh   Juice, Cold Milk, Chocos,Sambar | Pickle, B,B,J Tea, Coffee, Milk  | Salad,   Boiled Egg Masala",
            "lunch": "Phulka, Dal Maharani,  Mushroom  Peas  Masala,  | Dhai Vada,   Dal Rasam, Fryums,   | White Rice, Karakozhambu  / Sambar | Sweet :   Milk Peda",
            "snacks": "French Fries  | Sauce  | Ice Lemon Tea | Coffee ",
            "dinner": "Phulka, Dal Rajma, Veg & Egg Fried Rice       | Aloo capsicum  Masala, Garlic Sauce  | White Rice, Sambar, Rasam, Curd  | Spring Onion Soup, Fruits :   Musk melon "
          },
          "3": {
            "breakfast": "Paav Bhaji  / Vada Paav, Pongal, Vada | Fresh  Juice, Cold Milk,  Corn Flakes | B,B,J Tea, Coffee, Milk , Sambar, Chutney  | Green Salad,   Egg Burji (2nos)",
            "lunch": "Phulka,Dal tadka,Chicken Biryani,Veg Biryani,  | Banaras Baigan,Crumb Fry Panneer,Onion Raitha | White Rice, Sambar, Tomato Rasam, Papad,  | Sweet :   Assorted Ice Cream ",
            "snacks": "Paneer Puffs |   |    | Tea, Coffee, Milk",
            "dinner": " Phulka, Dal Banjara,    Baby Corn Masala  | White Rice, Drumstick Sambar,  Poriyal | Butter Milk, Mint Pulav , Rasam | Sweet corn Soup, Fruits : Papaya "
          },
          "5": {
            "breakfast": "Aloo Paratha, Curd, Kitchadi, Chutney   | Fresh   Juice, Cold Milk, Chocos,Sambar | Pickle, B,B,J Tea, Coffee, Milk  | Salad,   Boiled Egg Masala",
            "lunch": "Phulka, Dal Maharani,  Mushroom  Peas  Masala,  | Dhai Vada,   Dal Rasam, Fryums,   | White Rice, Karakozhambu  / Sambar | Sweet :   Milk Peda",
            "snacks": "French Fries  | Sauce  | Ice Lemon Tea | Coffee ",
            "dinner": "Phulka, Dal Rajma, Veg & Egg Fried Rice       | Aloo capsicum  Masala, Garlic Sauce  | White Rice, Sambar, Rasam, Curd  | Spring Onion Soup, Fruits :   Musk melon "
          },
          "6": {
            "breakfast": "Paav Bhaji  / Vada Paav, Pongal, Vada | Fresh  Juice, Cold Milk,  Corn Flakes | B,B,J Tea, Coffee, Milk , Sambar, Chutney  | Green Salad,   Egg Burji (2nos)",
            "lunch": "Phulka,Dal tadka,Chicken Biryani,Veg Biryani,  | Banaras Baigan,Crumb Fry Panneer,Onion Raitha | White Rice, Sambar, Tomato Rasam, Papad,  | Sweet :   Assorted Ice Cream ",
            "snacks": "Paneer Puffs |   |    | Tea, Coffee, Milk",
            "dinner": " Phulka, Dal Banjara,    Baby Corn Masala  | White Rice, Drumstick Sambar,  Poriyal | Butter Milk, Mint Pulav , Rasam | Sweet corn Soup, Fruits : Papaya "
          },
          "7": {
            "breakfast": "Poori, Aloo Masala,  Semiya, Chutney  | Banana Milk Shake,  Cold Milk, Chocos  | B,B,J Tea, Coffee, Milk, Mint Chutney  | Cow Peas Salad,   French toast,  ",
            "lunch": "Phulka,  Chilly  Chicken, Dragon Panneer  | Thai Fried Rice, Poriyal, Dhal Fry | White Rice, Sambar, Rasam, Wheel Chips, Curd | Sweet :  Lavangalatha",
            "snacks": "Donut |   | Sauce  | Tea, Coffee, Milk ",
            "dinner": " Plain Dosa, Dal Panchmela, Sambar, Chutney | Veg Jal Frizhi, Methi Roti   | White Rice, Rasam,  Butter Milk  | Cream of Mushroom, Fruits : Fresh  Fruits "
          },
          "8": {
            "breakfast": "Idly, Vada, Sambar, Veg Kitchadi, Chutney  | Fresh  Juice, Cold Milk, Cornflakes  | B,B,J,  Tea, Coffee, Milk  | Black eye Peas Salad,  Fried Eggs",
            "lunch": " Phulka, Dal Thadka, Channa Masala  | White Rice, Pineapple Rasam, Butter Milk  | Bisibilla Huliyana, Potato Chips , Poriyal  | Sweet :   Carrot Halwa  ",
            "snacks": "Veg Samosa  | Imly Chutney  | Jal Jeera  | Coffee, Mik ",
            "dinner": "Chapathi, Veg & Egg  Schezwan Fried Rice  | Dhal, Long Beans Sabzhi, Garlic sauce | White Rice, Sambar, Rasam, Butter Milk  | Veg Manchow Soup,Hot Badam Milk,Banana"
          },
          "9": {
            "breakfast": "Masala Dosa(THIN), Sambar,  | Chutney, Fresh  Juice, Cold Milk, Chocos  | B,B,J Tea, Coffee, Milk  | Green Salad, Egg Burji ( 2 nos)",
            "lunch": "Phulka,Butter Chicken Masala,Shahi  Panneer  | Arvi Fry, Dhal Lasoni,  Curd, Fryums | White Rice, Kadhambam Sambar, Tomato Rasam,   | Sweet :   Rasmalai / Rasagula ",
            "snacks": "Channa chat / | Masala Chat  | Sauce  | Tea, Coffee, Milk ",
            "dinner": "Phulka, Dal Maharani, Bindi Jaipuri | Veg Jal Frizhi, White Rice, Sambar  | Rasam,  Peas Pulav, Butter Milk  | Corriander Soup,  Papaya & Water Melon"
          },
          "10": {
            "breakfast": "Panneer Paratha,  Rava  Upma, Sambar | Dates Milk Shake, Cold Milk, Cornflakes  | B,B,J Tea, Coffee, Milk , Chutney  | Sweet Corn Salad,  Fried Eggs (2nos)",
            "lunch": "Phulka,Baked Egg/Fish Masala,Panneer Kuftha    | White Rice, Sambar, Rasam,  Aloo Baigan | Fryums, Dal Panchamela, Loose Curd  | Sweet:Bread Halwa ",
            "snacks": "Veg Sandwich/ | Hot dog, | Hot Badam Milk, | Tea, ",
            "dinner": "Poori, Channa Masala, White Rice, Rasam | Jeera Rice, Poriyal  | Loose Curd | Mixed veg Soup,  Fruits :   Orange"
          },
          "11": {
            "breakfast": "Masala Ghee Roast Dosa(Thin), Sambar,   | Fresh  Juice, Cold Milk, Chocos, Chutney | B,B,J,  Tea, Coffee, Milk  | Moong Dal Sprout,  Boiled Fry Eggs (2)",
            "lunch": "Phulka, Dal Fry,Chiken Tikka/Tandoori,Panneer  | Amritsari, White rice, Sambar, Poondu Rasam,   | Loose Curd,  Fryums, Keera  Kootu  | Sweet :  Gulab Jamun/ Makhan peda ",
            "snacks": "Brownie Cake | Eggless Cake |   | Tea,Coffee, Milk",
            "dinner": "Phulka, Dal  Maharani | White Rice,   Dhum Aloo / Banaras Aloo  | Rasam,  Curd, Meal Maker Pulav  | Cream of Tomato, Fruits :   Papaya "
          },
          "12": {
            "breakfast": "Mixed Veg Paratha, Curd, Kitchadi, Chutney   | Fresh  Juice, Cold Milk, Chocos,Sambar | B,B,J Tea, Coffee, Milk  | Salad,  Egg Burji (2)",
            "lunch": "Phulka, Dal Makhani,   Dingri Muttar,  |  Dahi Vada , Poriyal, Sambar / Karakolambu  | White Rice, Paruppu Rasam, Fryums,    | Sweet : Ghee Mysore Paak ",
            "snacks": "Masala Vada | Chutney | Masala Tea |  Coffee, Milk",
            "dinner": "Phulka, Dal Fry,  Veg  Egg & Veg Rice  | Baby corn  Manchurian, Poriyal, Loose Curd | White Rice, Sambar, Rasam  | Fresh garden peas Soup,Fruits:Fresh Fruits "
          },
          "13": {
            "breakfast": "Podi Idly,Paav Bhaji, Sambar,Chutney,  | Cold Milk, Corn Flakes,Tea, Coffee, Milk, | Fresh Juice, B,B,J Sprouted Channa Black |   Spanish Omelette",
            "lunch": "Phulka, Dal, Chicken Biryani, Veg Biryani,  | Banaras Baigan, Dragan Panneer, Onion Raitha | White Rice,Sambar,Tomato Rasam, Papad,  | Sweet :  Ice Cream  ",
            "snacks": " Hot Dog (Sauce) | Dahi Papdi Chat  | Jal Jeera  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dal Masala,   Butter Peas masala | White Rice, Sambar, Rasam,  Aloo Jeera   | Curd, Variety Rice  | Sweet corn Soup, Fruits :  Cut Fruits "
          },
          "14": {
            "breakfast": "Poori, Aloo Masala, Poha Nampkin | Banana Milk Shake, Cold Milk, Chocos  | B,B,J Tea, Coffee, Milk , Mint Chutney | Cow Peas Salad, Masala Omelette",
            "lunch": "Phulka, Kadai Chicken Masala,  Dal Fry | Panneer Butter Masala, Poriyal,  Loose Curd | White Rice, Sambar, Pepper Rasam, Wheel Chips  | Sweet : Mothichoor Laddu/   Rava Laddu ",
            "snacks": "Mysore Bonda / | Masala Sweet  | Corn (1 cup) | Tea, Coffee, Milk",
            "dinner": "Pudhina Roti , Plain Dosa, Sambar, Chutney | Loose Curd , Dhal Maharani, Channa Masala  | White Rice, Rasam,    | Veg  Mushroom Soup, Fruits : Seasonal "
          },
          "15": {
            "breakfast": "Gobi Paratha, Curd,  Kitchadi, Sambar | Date Milk Shake, Cold Milk, Cornflakes  | B,B,J,Pickle,  Tea, Coffee, Milk, Chutney | Black eye Peas Salad,  Fried Eggs ",
            "lunch": "Phulka, Dal  Ajwin, Veg Jal Frizhe | White Rice,   Pineapple Rasam , Curd  | Bisibilla Bath, Potato Chips  | Sweet : Carrot Halwa  ",
            "snacks": "Onion Samosa/ | Veg Samosa  | Imly Chutney  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dal Fry,Veg & Egg  Fried Rice  |  Baby Corn Manchurian,  Poriyal | White Rice, Sambar, Rasam,  Curd  | Veg Manchow Soup, Cut Fruits "
          },
          "16": {
            "breakfast": "Mysore  Masala Dosa(Thin) Sambar,Chutney  | Fresh  Juice, Cold Milk, Chocos  | B,B,J Tea, Coffee, Milk  | Green Salad,    Egg Burji ( 2 nos )",
            "lunch": "Diamond Chapathi, Dal Fry,  Nilagiri Chicken  | Panneer  Hariyali, Curd, Aloo Methi/  Aloo | Saagwala, White Rice, Sambar, Rasam, Fryums | Sweet :  Gova Jangri ",
            "snacks": "Veg Burger/ | Potato Croissant fry | Sauce  | Tea, Coffee, Milk ",
            "dinner": "Phulka, Dal Maharani, Bindi Jaipuri |  Aloo Dhum, White Rice, Sambar  | Rasam, Loose Curd,  Puliyodra  | Milaguthunia Soup, Fruits :  Papaya"
          },
          "17": {
            "breakfast": " Panneer Paratha,  Pongal, Vada, Sambar | Fresh Juice,Cold Milk,Cornflakes,Chutney  | B,B,J Tea, Coffee, Milk  | Black Channa Sprout,Boiled Eggs(2 nos) ",
            "lunch": " Phulka, Malabar Fish Curry/Masala Fried Fish  | Nargesi Kuftha Curry, White Rice, Sambar,  | Wheel Chips, Dal Fry,  Butter Milk,Rasam  | Sweet:Rasmalai/ Rasagula  ",
            "snacks": "Spring roll | Sauce  |   | Tea, Coffee, Milk ",
            "dinner": "Poori, Channa Masala ,White Rice, Rasam | Vaangi Baath, Poriyal  | Curd   | Cr. Of  Brocoli Soup,  Fruit Salad "
          },
          "18": {
            "breakfast": "Kal Dosa, Vada Curry, Chutney,   | Fresh  Juice, Cold Milk, Cornflakes  | B,B,J Tea, Coffee, Milk  | Moong Dal Sprout,  Scrambeled Egg(2)",
            "lunch": "Phulka,Dhal,Tandoori Chicken,Panneer Fingers | White rice,Sambar,Gr.Veg Sabzhi(without potato) | Curd,Fryums, Pineapple Rasam  | Sweet:Gulab Jamun / Makhan peda ",
            "snacks": "Brownie Cake/ |   | Hot Badam Milk | Tea, Coffee, Milk ",
            "dinner": "Phulka, Dal Makhani,Idly, Sambar, Chutney  | White Rice,Dhum Aloo/Banaras Aloo, | White rice,Rasam, Loose Curd,   | Cream of Tomato, Fruits :  Fresh Fruits "
          },
          "19": {
            "breakfast": "Aloo Paratha, Curd, Kitchadi, Chutney   | Fresh   Juice, Cold Milk, Chocos,Sambar | Pickle, B,B,J Tea, Coffee, Milk  | Salad,   Boiled Egg Masala",
            "lunch": "Phulka, Dal Maharani,  Mushroom  Peas  Masala,  | Dhai Vada,   Dal Rasam, Fryums,   | White Rice, Karakozhambu  / Sambar | Sweet :   Milk Peda",
            "snacks": "French Fries  | Sauce  | Ice Lemon Tea | Coffee ",
            "dinner": "Phulka, Dal Rajma, Veg & Egg Fried Rice       | Aloo capsicum  Masala, Garlic Sauce  | White Rice, Sambar, Rasam, Curd  | Spring Onion Soup, Fruits :   Musk melon "
          },
          "20": {
            "breakfast": "Paav Bhaji  / Vada Paav, Pongal, Vada | Fresh  Juice, Cold Milk,  Corn Flakes | B,B,J Tea, Coffee, Milk , Sambar, Chutney  | Green Salad,   Egg Burji (2nos)",
            "lunch": "Phulka,Dal tadka,Chicken Biryani,Veg Biryani,  | Banaras Baigan,Crumb Fry Panneer,Onion Raitha | White Rice, Sambar, Tomato Rasam, Papad,  | Sweet :   Assorted Ice Cream ",
            "snacks": "Paneer Puffs |   |    | Tea, Coffee, Milk",
            "dinner": " Phulka, Dal Banjara,    Baby Corn Masala  | White Rice, Drumstick Sambar,  Poriyal | Butter Milk, Mint Pulav , Rasam | Sweet corn Soup, Fruits : Papaya "
          },
          "21": {
            "breakfast": "Poori, Aloo Masala,  Semiya, Chutney  | Banana Milk Shake,  Cold Milk, Chocos  | B,B,J Tea, Coffee, Milk, Mint Chutney  | Cow Peas Salad,   French toast,  ",
            "lunch": "Phulka,  Chilly  Chicken, Dragon Panneer  | Thai Fried Rice, Poriyal, Dhal Fry | White Rice, Sambar, Rasam, Wheel Chips, Curd | Sweet :  Lavangalatha",
            "snacks": "Donut |   | Sauce  | Tea, Coffee, Milk ",
            "dinner": " Plain Dosa, Dal Panchmela, Sambar, Chutney | Veg Jal Frizhi, Methi Roti   | White Rice, Rasam,  Butter Milk  | Cream of Mushroom, Fruits : Fresh  Fruits "
          },
          "22": {
            "breakfast": "Idly, Vada, Sambar, Veg Kitchadi, Chutney  | Fresh  Juice, Cold Milk, Cornflakes  | B,B,J,  Tea, Coffee, Milk  | Black eye Peas Salad,  Fried Eggs",
            "lunch": " Phulka, Dal Thadka, Channa Masala  | White Rice, Pineapple Rasam, Butter Milk  | Bisibilla Huliyana, Potato Chips , Poriyal  | Sweet :   Carrot Halwa  ",
            "snacks": "Veg Samosa  | Imly Chutney  | Jal Jeera  | Coffee, Mik ",
            "dinner": "Chapathi, Veg & Egg  Schezwan Fried Rice  | Dhal, Long Beans Sabzhi, Garlic sauce | White Rice, Sambar, Rasam, Butter Milk  | Veg Manchow Soup,Hot Badam Milk,Banana"
          },
          "23": {
            "breakfast": "Masala Dosa(THIN), Sambar,  | Chutney, Fresh  Juice, Cold Milk, Chocos  | B,B,J Tea, Coffee, Milk  | Green Salad, Egg Burji ( 2 nos)",
            "lunch": "Phulka,Butter Chicken Masala,Shahi  Panneer  | Arvi Fry, Dhal Lasoni,  Curd, Fryums | White Rice, Kadhambam Sambar, Tomato Rasam,   | Sweet :   Rasmalai / Rasagula ",
            "snacks": "Channa chat / | Masala Chat  | Sauce  | Tea, Coffee, Milk ",
            "dinner": "Phulka, Dal Maharani, Bindi Jaipuri | Veg Jal Frizhi, White Rice, Sambar  | Rasam,  Peas Pulav, Butter Milk  | Corriander Soup,  Papaya & Water Melon"
          },
          "24": {
            "breakfast": "Panneer Paratha,  Rava  Upma, Sambar | Dates Milk Shake, Cold Milk, Cornflakes  | B,B,J Tea, Coffee, Milk , Chutney  | Sweet Corn Salad,  Fried Eggs (2nos)",
            "lunch": "Phulka,Baked Egg/Fish Masala,Panneer Kuftha    | White Rice, Sambar, Rasam,  Aloo Baigan | Fryums, Dal Panchamela, Loose Curd  | Sweet:Bread Halwa ",
            "snacks": "Veg Sandwich/ | Hot dog, | Hot Badam Milk, | Tea, ",
            "dinner": "Poori, Channa Masala, White Rice, Rasam | Jeera Rice, Poriyal  | Loose Curd | Mixed veg Soup,  Fruits :   Orange"
          },
          "25": {
            "breakfast": "Masala Ghee Roast Dosa(Thin), Sambar,   | Fresh  Juice, Cold Milk, Chocos, Chutney | B,B,J,  Tea, Coffee, Milk  | Moong Dal Sprout,  Boiled Fry Eggs (2)",
            "lunch": "Phulka, Dal Fry,Chiken Tikka/Tandoori,Panneer  | Amritsari, White rice, Sambar, Poondu Rasam,   | Loose Curd,  Fryums, Keera  Kootu  | Sweet :  Gulab Jamun/ Makhan peda ",
            "snacks": "Brownie Cake | Eggless Cake |   | Tea,Coffee, Milk",
            "dinner": "Phulka, Dal  Maharani | White Rice,   Dhum Aloo / Banaras Aloo  | Rasam,  Curd, Meal Maker Pulav  | Cream of Tomato, Fruits :   Papaya "
          },
          "26": {
            "breakfast": "Mixed Veg Paratha, Curd, Kitchadi, Chutney   | Fresh  Juice, Cold Milk, Chocos,Sambar | B,B,J Tea, Coffee, Milk  | Salad,  Egg Burji (2)",
            "lunch": "Phulka, Dal Makhani,   Dingri Muttar,  |  Dahi Vada , Poriyal, Sambar / Karakolambu  | White Rice, Paruppu Rasam, Fryums,    | Sweet : Ghee Mysore Paak ",
            "snacks": "Masala Vada | Chutney | Masala Tea |  Coffee, Milk",
            "dinner": "Phulka, Dal Fry,  Veg  Egg & Veg Rice  | Baby corn  Manchurian, Poriyal, Loose Curd | White Rice, Sambar, Rasam  | Fresh garden peas Soup,Fruits:Fresh Fruits "
          },
          "27": {
            "breakfast": "Podi Idly,Paav Bhaji, Sambar,Chutney,  | Cold Milk, Corn Flakes,Tea, Coffee, Milk, | Fresh Juice, B,B,J Sprouted Channa Black |   Spanish Omelette",
            "lunch": "Phulka, Dal, Chicken Biryani, Veg Biryani,  | Banaras Baigan, Dragan Panneer, Onion Raitha | White Rice,Sambar,Tomato Rasam, Papad,  | Sweet :  Ice Cream  ",
            "snacks": " Hot Dog (Sauce) | Dahi Papdi Chat  | Jal Jeera  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dal Masala,   Butter Peas masala | White Rice, Sambar, Rasam,  Aloo Jeera   | Curd, Variety Rice  | Sweet corn Soup, Fruits :  Cut Fruits "
          },
          "28": {
            "breakfast": "Poori, Aloo Masala, Poha Nampkin | Banana Milk Shake, Cold Milk, Chocos  | B,B,J Tea, Coffee, Milk , Mint Chutney | Cow Peas Salad, Masala Omelette",
            "lunch": "Phulka, Kadai Chicken Masala,  Dal Fry | Panneer Butter Masala, Poriyal,  Loose Curd | White Rice, Sambar, Pepper Rasam, Wheel Chips  | Sweet : Mothichoor Laddu/   Rava Laddu ",
            "snacks": "Mysore Bonda / | Masala Sweet  | Corn (1 cup) | Tea, Coffee, Milk",
            "dinner": "Pudhina Roti , Plain Dosa, Sambar, Chutney | Loose Curd , Dhal Maharani, Channa Masala  | White Rice, Rasam,    | Veg  Mushroom Soup, Fruits : Seasonal "
          },
          "29": {
            "breakfast": "Gobi Paratha, Curd,  Kitchadi, Sambar | Date Milk Shake, Cold Milk, Cornflakes  | B,B,J,Pickle,  Tea, Coffee, Milk, Chutney | Black eye Peas Salad,  Fried Eggs ",
            "lunch": "Phulka, Dal  Ajwin, Veg Jal Frizhe | White Rice,   Pineapple Rasam , Curd  | Bisibilla Bath, Potato Chips  | Sweet : Carrot Halwa  ",
            "snacks": "Onion Samosa/ | Veg Samosa  | Imly Chutney  | Tea, Coffee, Milk",
            "dinner": "Phulka, Dal Fry,Veg & Egg  Fried Rice  |  Baby Corn Manchurian,  Poriyal | White Rice, Sambar, Rasam,  Curd  | Veg Manchow Soup, Cut Fruits "
          },
          "30": {
            "breakfast": "Mysore  Masala Dosa(Thin) Sambar,Chutney  | Fresh  Juice, Cold Milk, Chocos  | B,B,J Tea, Coffee, Milk  | Green Salad,    Egg Burji ( 2 nos )",
            "lunch": "Diamond Chapathi, Dal Fry,  Nilagiri Chicken  | Panneer  Hariyali, Curd, Aloo Methi/  Aloo | Saagwala, White Rice, Sambar, Rasam, Fryums | Sweet :  Gova Jangri ",
            "snacks": "Veg Burger/ | Potato Croissant fry | Sauce  | Tea, Coffee, Milk ",
            "dinner": "Phulka, Dal Maharani, Bindi Jaipuri |  Aloo Dhum, White Rice, Sambar  | Rasam, Loose Curd,  Puliyodra  | Milaguthunia Soup, Fruits :  Papaya"
          },
          "31": {
            "breakfast": " Panneer Paratha,  Pongal, Vada, Sambar | Fresh Juice,Cold Milk,Cornflakes,Chutney  | B,B,J Tea, Coffee, Milk  | Black Channa Sprout,Boiled Eggs(2 nos) ",
            "lunch": " Phulka, Malabar Fish Curry/Masala Fried Fish  | Nargesi Kuftha Curry, White Rice, Sambar,  | Wheel Chips, Dal Fry,  Butter Milk,Rasam  | Sweet:Rasmalai/ Rasagula  ",
            "snacks": "Spring roll | Sauce  |   | Tea, Coffee, Milk ",
            "dinner": "Poori, Channa Masala ,White Rice, Rasam | Vaangi Baath, Poriyal  | Curd   | Cr. Of  Brocoli Soup,  Fruit Salad "
          },

        },
      }
      const stringifiedMenus = JSON.stringify(fetchedMenus);
      localStorage.setItem('menus', stringifiedMenus);
      localStorage.setItem('storedDate', currDate);
      setMenus(fetchedMenus[selectedMenuType]);
    }

  }, [selectedMenuType]);



  const weekDays = ['', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'
  ];



  const genZJokes = [
    "",
    "Aryan - I’m not scrolling through TikTok; I’m conducting vital research on current trends.",
    "Siya - My phone battery percentage is a direct reflection of my motivation levels.",
    "Veer - Instant noodles are my love language; they understand me better than most people.",
    "Tara - I joined the photography club for the aesthetic, stayed for the editing tutorials.",
    "Kabir - I'm not disorganized; I just have a highly personalized filing system (it's called my backpack).",
    "Isha - Online classes are 99% muted and 1% awkwardly unmuting.",
    "Neil - The cafeteria food isn’t that questionable… if you add enough hot sauce.",
    "Aisha - I don't need a personal trainer; rushing to submit assignments is my workout.",
    "Dhruv - I’m not obsessed with coffee; it’s just my liquid sanity.",
    "Maya - The library is my happy place… as long as the Wi-Fi is working.",
    "Yash - I’m not procrastinating; I’m strategically delaying tasks for maximum efficiency (or something).",
    "Pari - Doing laundry is a form of self-care… if self-care involves existential dread.",
    "Rohan - I’ve achieved peak performance by surviving on caffeine and sheer willpower.",
    "Simran - Late-night study sessions are a vibe, especially when paired with questionable snacks.",
    "Aditya - Coding at 3 AM hits differently, especially when you finally fix that one bug.",
    "Naina - I don’t ghost people; I just have a very selective response time.",
    "Viraj - I’m not sleep-deprived; I’m operating on a different circadian rhythm (it’s called student time).",
    "Anika - Every group project has a designated meme creator, and I proudly hold that title.",
    "Samir - My attendance record is like a rollercoaster: full of unexpected dips and turns.",
    "Sakshi - I’m not broke; I just invest wisely in online shopping therapy.",
    "Ria - The dining hall menu is a gamble, and I’m always willing to take the risk (sometimes regrettably).",
    "Zoya - The only constant in my life is the ever-growing collection of charging cables.",
    "Atharv - My backpack is a black hole where assignments go to disappear forever.",
    "Kavya - University life taught me two things: how to survive on minimal sleep and how to perfectly time my bathroom breaks between classes.",
    "Vedant - I’m not skipping lectures; I'm just maximizing my sleep quota.",
    "Trisha - I joined the debate club, but my favorite part is still the post-debate snacks.",
    "Reyansh - Group projects are where one person carries the team, and the others offer moral support (and occasional memes).",
    "Diya - Every exam feels like a plot twist, even when I think I’m prepared.",
    "Ishaan - Exams are the only time I discover hidden messages in my lecture notes.",
    "Anisha - University Wi-Fi can make even the most patient person lose their mind.",
    "Sam - Not a joke but once the fire alarm went off during one of my classes and the prof just shut the door and continued teaching.",
  ];


  const handleMenuTypeSelect = (menuType) => {
    setSelectedMenuType(menuType);
    localStorage.setItem('selectedMenuType', menuType);
  };



  const getMenuForDay = (day) => {
    const menu = menus[day];
    if (!menu) {
      console.warn(`Menu not found for day ${day}`);
      return null;
    }
    return menu;
  };

  const [message, setMessage] = useState('');

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const [name, setName] = useState('');

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const [typejoke, setTypejoke] = useState('');

  const handleJokeChange = (event) => {
    setTypejoke(event.target.value);
  };
  const riddleSubmissions = [
    'Varun - Would have a power to Control Minds, Will make faculty give me S grade, will make chief warden to organise dj nights in mens hostel too, and would get placed with the maximum CTC',
    'Tar - MindRead : I will get to know toppers answes in CATs',
    'Mike Ross - Use his photographic memory to memorise my subjects(watch suits)',
    'Shrivatsa  - Flashs superspeed will help me slow down time and I will copy answers from the toppers sheet',
    'Sandy - Invisibility coz we go to classes to sleep',
    'Babu - Teleportation - I can get to academic blocks right after waking up ...',
    'SM - Stop the time and use phone during exams to get answers ',

  ];
  const dataRiddle = "If you could have any superpower that would realistically help you in college, what would it be and why?";
  const dataRiddleNextWeek = "What's a 'glitch in the matrix' moment you've had on campus that made you question reality?"
  const [riddle, setRiddle] = useState('');


  const handleRiddleChange = (event) => {
    setRiddle(event.target.value);
  };




  const handleSubmit = async (event) => {
    event.preventDefault();
    // Handle form submission, e.g., send data to backend or perform validation
    console.log('Message:', message);
    // You can add further logic here, like sending the review to a server
    // Reset form fields after submission if needed
    await sendMessageSubmitToTelegram(message);
    setMessage('');
  };

  const handleJoke = async (event) => {
    event.preventDefault();
    console.log(name, typejoke);
    await sendJokeToTelegram(name, typejoke);
    window.alert("Your Joke has been sent! Please ensure the language is appropriate to increase the chances of it being shortlisted for others to see. 😊");

    localStorage.setItem('name', name);
    setName('');
    setTypejoke('');
  }

  const handleRiddle = async (event) => {
    event.preventDefault();
    console.log(name, riddle);

    await sendJokeToTelegram("Riddle -" + dataRiddleNextWeek + " by- " + name, riddle);
    window.alert("Your message has been sent! Please ensure the language is appropriate to increase the chances of it being shortlisted for others to see. 😊");
    localStorage.setItem('name', name);
    setName('');
    setRiddle('');
  }



  const [clickedTimes, setClickedTimes] = useState(0);


  const [emoji, setemoji] = useState(false);
  const emojisend = async (event) => {
    console.log("laughing");
    setemoji(true);
    setLike(false);
    if (localStorage.getItem('name')) {
      setName(localStorage.getItem('name'));
    }

    if (clickedTimes < 2) {
      setClickedTimes(clickedTimes + 1); // Increment clickedTimes
      await sendJokeToTelegram(name, "laughing");
    }

  }

  const [like, setLike] = useState(false);
  const likesend = async (event) => {
    console.log("liked");
    setLike(true);
    setemoji(false);
    if (localStorage.getItem('name')) {
      setName(localStorage.getItem('name'));
    }

    if (clickedTimes < 2) {
      setClickedTimes(clickedTimes + 1); // Increment clickedTimes
      await sendJokeToTelegram(name, "liked");
    }


  }


  useEffect(() => {
    if (localStorage.getItem('name')) {
      setName(localStorage.getItem('name'));
    }
    sendMessageToTelegram(message);
  }, []);




  const currentTime = new Date().toLocaleString();
  const currentMonth = new Date().getMonth(); // January is 0, February is 1, ..., December is 11

  const sendMessageToTelegram = async (message) => {
    try {
      const response = await fetch('https://api.telegram.org/bot6270744341:AAFpOfrQj1RFEHKwx8qfo8W77oc7et0iTM0/sendMessage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          chat_id: '-1002035897228',
          text: `Men - ${currentTime}`
        })
      });

      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error('Error message:', error);
    }
  };

  const sendMessageSubmitToTelegram = async (message) => {
    try {
      const response = await fetch('https://api.telegram.org/bot6842910125:AAHtoikFcZgSLih4i7dfkDyQmYxO0IPM2s8/sendMessage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          chat_id: '-1002047632263',
          text: `Men - ${currentTime} Message - ${message}`
        })
      });

      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error('Error message:', error);
    }
  };

  const sendJokeToTelegram = async (namee, typejokee) => {
    try {
      const response = await fetch('https://api.telegram.org/bot7132361049:AAFz9hWhsn64mQHP5DZWWQqERKrVAQY87YE/sendMessage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          chat_id: '-1002067896338',
          text: `(Men - ${currentTime}) - ${namee} - ${typejokee}`
        })
      });

      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error('Error message:', error);
    }
  };


  const reveal = () => {
    const reveals = document.querySelectorAll(".reveal");
    for (let i = 0; i < reveals.length; i++) {
      const windowHeight = window.innerHeight;
      const elementTop = reveals[i].getBoundingClientRect().top;
      const elementVisible = 100;

      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add("active");
      } else {
        reveals[i].classList.remove("active");
      }
    }
  };




  const rotatee = () => {
    const rotatees = document.querySelectorAll(".rotatee");
    for (let i = 0; i < rotatees.length; i++) {
      const windowHeight = window.innerHeight;
      const elementTop = rotatees[i].getBoundingClientRect().top;
      const elementVisible = 100;

      if (elementTop < windowHeight - elementVisible) {
        rotatees[i].classList.add("active");
      } else {
        rotatees[i].classList.remove("active");
      }
    }
  };



  useEffect(() => {
    reveal();
    rotatee();

    window.addEventListener('scroll', () => {
      reveal();
      rotatee();
    });

    return () => window.removeEventListener('scroll', () => { });
  }, []);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Simulate animation trigger on component mount (like a refresh)
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const [slidefromUp, setslidefromUp] = useState(false);

  useEffect(() => {
    // Simulate animation trigger on component mount (like a refresh)
    setTimeout(() => setslidefromUp(true), 100);
  }, []);









  const [theme, setTheme] = useState('automatic');

  // Function to initialize theme based on local storage or device preference
  const initializeTheme = () => {
    const storedTheme = localStorage.getItem('theme');
    const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (storedTheme === 'dark' || storedTheme === 'light') {
      setTheme(storedTheme);
    } else {
      setTheme(prefersDarkMode ? 'dark' : 'light');
    }
  };

  useEffect(() => {
    initializeTheme(); // Initialize theme when component mounts
  }, []);

  const setAutomaticTheme = () => {
    const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const themeToSet = prefersDarkMode ? 'dark' : 'light';
    setTheme(themeToSet);
    localStorage.setItem('theme', 'automatic');
  };

  const setLightTheme = () => {
    setTheme('light');
    localStorage.setItem('theme', 'light');
  };

  const setDarkTheme = () => {
    setTheme('dark');
    localStorage.setItem('theme', 'dark');
  };




  const [showButtons, setShowButtons] = useState(false);

  const toggleButtons = () => {
    setShowButtons((prevShowButtons) => !prevShowButtons);
  };

  const [showMore, setShowMore] = useState(false);

  const toggleMore = () => {
    setShowMore((prevShowMore) => !prevShowMore);
  };

  const [toggleRiddle, setToggleRiddle] = useState(false);
  const toggleRiddleButton = () => {
    setToggleRiddle((toggleRiddle) => !toggleRiddle);
  }


  return (

    <div className={`flex overflow-hidden  sm:p-5 justify-center ${theme === 'dark' ? 'bg-slate-950' : 'bg-sky-50'}`}>
      <div className='sm:p-5 p-5 flex sm:w-2/3 w-full flex-col justify-center'>



        <div className='flex-1 flex-col flex items-center'>
          <div className={`m-2 p-1 sm:w-2/3 w-full flex flex-row rounded-full   ${theme === 'dark' ? 'bg-sky-950' : 'bg-sky-100'} opacity-0 transition-all duration-300 ease-in-out ${slidefromUp ? 'opacity-100 -transky-y-0 p-1 sm:w-2/3' : '-transky-y-20 sm:pl-20 sm:pr-20 pt-50 pb-20 sm:w-1.5'} `}>
            <button
              className={`flex w-1/3 justify-center font-bold transition-all p-3 m-2 rounded-full 
            ${selectedMenuType === "veg"
                  ? theme === 'dark'
                    ? 'text-sky-50 bg-green-700 hover:bg-green-600'
                    : 'text-black bg-green-400 hover:bg-green-300'
                  : theme === 'dark'
                    ? 'text-sky-50 hover:bg-sky-900 bg-sky-950'
                    : 'text-black hover:bg-sky-200 bg-sky-100'
                }`}
              onClick={() => handleMenuTypeSelect('veg')}
            > Veg
            </button>

            <button
              className={`flex w-1/3 justify-center font-bold transition-all p-3 m-2 rounded-full 
            ${selectedMenuType === "special"
                  ? theme === 'dark'
                    ? 'text-sky-50 bg-sky-800 hover:bg-sky-600'
                    : 'text-black  bg-sky-400 hover:bg-sky-300 '
                  : theme === 'dark'
                    ? 'text-sky-50 hover:bg-sky-900 bg-sky-950'
                    : 'text-black hover:bg-sky-200 bg-sky-100'
                }`}
              onClick={() => handleMenuTypeSelect('special')}
            > Special
            </button>

            <button
              className={`flex w-1/3 justify-center font-bold transition-all p-3 m-2 rounded-full 
            ${selectedMenuType === "nonVeg"
                  ? theme === 'dark'
                    ? 'text-sky-50 bg-red-800 hover:bg-red-600'
                    : 'text-black  bg-red-400 hover:bg-red-300 '
                  : theme === 'dark'
                    ? 'text-sky-50 hover:bg-sky-900 bg-sky-950'
                    : 'text-black hover:bg-sky-200 bg-sky-100'
                }`}
              onClick={() => handleMenuTypeSelect('nonVeg')}
            > Non-Veg
            </button>

          </div>












          <h2 className={`text-xl mt-3 font-bold ${theme === 'dark' ? 'text-white ' : 'text-sky-600'}`}>
            {((currentDay === today.getDate()) ? "( Today )" : (currentDay === (today.getDate() - 1) % 28) ? "( Yesterday )" : (currentDay === (today.getDate() + 1) % 28) ? "( Tomorrow )" : "")}
          </h2>
          <h2 className={`text-3xl mt-3 font-extrabold ${theme === 'dark' ? 'text-gray-200' : ''}`}>
            July {currentDay} - {weekDays[currentDay]}
          </h2>

          <div className='flex w-full mt-2 justify-between '>
            <button className={` hover:underline p-2 m-2 rounded ${theme === 'dark' ? 'text-white' : ' text-black'}`} onClick={() => setCurrentDay((currentDay - 1 >= 1) ? currentDay - 1 : today.getDate())}>&lt;&lt; Previous Day</button>
            <button className={` hover:underline p-2 m-2 rounded ${theme === 'dark' ? ' text-white' : ' text-black'}`} onClick={() => setCurrentDay((currentDay + 1 <= 31) ? currentDay + 1 : today.getDate())}>Next Day &gt;&gt;</button>
          </div>
        </div>
        {currentMonth === 6 && getMenuForDay(currentDay) ? (
          <div>

            {Object.entries(getMenuForDay(currentDay)).map(([sectionName, menuItems]) => (
              <div className={`m-3 mt-7  p-4 rounded-lg  opacity-0 transition-all duration-500 ease-in-out 
              ${isVisible ? 'opacity-100 transky-y-0' : 'transky-y-20'}   dark: ${theme === 'dark' ? '  bg-sky-800 shadow-md border-sky-200 border-b-4 ' : ' bg-sky-100 border-sky-500 shadow-md border-b-4'}
              ${(sectionName === "breakfast" && (currentDay === 7 || currentDay === 8 || currentDay === 14 || currentDay === 15 || currentDay === 21 || currentDay === 22 || currentDay === 28 || currentDay === 29) && ((currHour === 7 && currMin >= 30) || (currHour > 7)) && ((currHour === 9 && currMin <= 15) || (currHour < 9)))
                  || (sectionName === "breakfast" && !(currentDay === 7 || currentDay === 8 || currentDay === 14 || currentDay === 15 || currentDay === 21 || currentDay === 22 || currentDay === 28 || currentDay === 29) && currHour >= 7 && currHour < 9)
                  || (sectionName === "lunch" && ((currHour === 12 && currMin >= 30) || (currHour > 12)) && ((currHour === 14 && currMin <= 30) || (currHour < 14)))
                  || (sectionName === "snacks" && ((currHour === 16 && currMin >= 30) || (currHour > 16)) && ((currHour === 18 && currMin <= 30) || (currHour < 18)))
                  || (sectionName === "dinner" && currHour >= 19 && currHour < 21)
                  ?
                  (theme === 'dark' ? '  bg-sky-800 shadow-slate-600 shadow-xl ml-1 mr-1 pt-6 pb-6 border-sky-200 border-b-8 ' : ' bg-sky-100 ml-1 mr-1 pt-6 pb-6 border-sky-500 shadow-slate-400 shadow-lg border-b-8') :
                  ""}

              `} key={sectionName}>
                <h3 className={`font-bold ${theme === 'dark' ? 'text-gray-100' : 'text-black'}  `}>{sectionName.toUpperCase()}:</h3>
                <p className={` ${theme === 'dark' ? 'text-gray-100' : 'text-black'}  `}>{menuItems}</p>
                <br></br>
                <p className={`font-medium ${theme === 'dark' ? 'text-gray-300' : 'text-sky-600'}  text-xs `}>{(sectionName === "breakfast" && (currentDay === 3 || currentDay === 9 || currentDay === 3 || currentDay === 9 || currentDay === 10 || currentDay === 16 || currentDay === 17 || currentDay === 23 || currDate === 24)) ? "7:15 AM - 9:30 AM" : (sectionName === "breakfast") ? "7:00 AM - 9:00 AM" : (sectionName === "lunch") ? "12:30 PM- 2:30 PM" : (sectionName === "snacks") ? "4:00 PM- 6:15 PM" : "7:00 PM - 9:00 PM"}</p>
              </div>
            ))}

          </div>
        ) : (
          <div className={` ${theme === 'dark' ? 'text-white' : 'text-black'}  `}>
            <p className='text-center'>Menu not available for this date. Please wait for one day so that we can fetch mess menu for you.</p>
          </div>
        )}




        <div className={` w-full mt-4 sm:w-full flex-col flex items-center`} onClick={toggleButtons}>
          <div className={`m-2  p-4 w-full flex flex-col items-center justify-center rounded-3xl   ${showButtons ? 'bg-opacity-100 shadow-md hover:bg-opacity-100' : ' bg-opacity-0 shadow-none hover:bg-opacity-70'}  
            ${theme === 'dark' ? 'bg-gray-800' : 'bg-slate-200 hover:bg-slate-200 shadow-md'}  `}>
            <div className='flex flex-row items-center'>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className={`w-6   h-6 ${theme === 'dark' ? 'fill-sky-900 text-gray-400 ' : 'fill-white text-gray-600'} `}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
              </svg>

              <span className={`flex pl-2 text-lg   font-semibold ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>  Settings</span>
            </div>
            {showButtons && (
              <>
                <button
                  className={`flex w-1/2 mt-8  justify-center font-bold transition-all p-3 m-2 rounded-full 
                ${theme === 'light' ? 'text-white bg-sky-400 hover:bg-sky-500' : 'text-white bg-gray-800 hover:bg-gray-700'}
              `}
                  onClick={setLightTheme}
                >
                  Light
                </button>

                <button
                  className={`flex w-1/2 justify-center font-bold transition-all p-3 m-2 rounded-full 
                ${theme === 'dark' ? 'text-white bg-sky-500 hover:bg-sky-600' : 'text-black bg-gray-200 hover:bg-gray-300'}
              `}
                  onClick={setDarkTheme}
                >
                  Dark
                </button>

                <button
                  className={`flex w-1/2 mt-10 justify-center font-bold transition-all p-3 m-2 rounded-full 
                ${theme === 'light' ? 'text-white bg-gray-700 hover:bg-gray-700' : 'text-black bg-gray-200 hover:bg-gray-300'}
              `}
                  onClick={setAutomaticTheme}
                >
                  Device
                </button>
              </>
            )}
          </div>
        </div>

        <div className={` reveal rotatee  mt-4 w-full font-mono font-bold   shadow-lg  rounded-2xl ${theme === 'dark' ? ' bg-gradient-to-bl from-sky-300 shadow-sky-500 to-violet-300 text-black' : 'bg-gradient-to-bl shadow-sky-600 from-sky-700 to-violet-700 text-white'}`}>
          <div className='p-5'>
            <p className=' text-md font-bold opacity-50 text-center '>J o k e B o x</p>
            <p className=' text-4xl font-extrabold '>"</p>
            {genZJokes[currDate]}
            <p className=' text-4xl text-right font-extrabold'>"</p>
            <div className={`flex flex-row items-center justify-center rounded-full w-fit p-2 ${theme === 'dark' ? 'bg-white bg-opacity-70' : 'bg-white bg-opacity-90'}`}>
              <button className={` rounded-full text-xl drop-shadow-md shadow-black transition-all    ${emoji === true ? 'opacity-100 rounded-full scale-125' : 'opacity-60 '} `} onClick={emojisend} alt="emoji">😂</button>
              <button className={` rounded-full text-xl drop-shadow-md shadow-black transition-all pl-4   ${like === true ? 'opacity-100 rounded-full scale-125' : 'opacity-60 '} `} onClick={likesend} alt="like">❤️</button>
            </div>
          </div>
        </div>

        <p className={`${theme === 'dark' ? 'text-slate-50' : 'text-black'}  font-normal mt-8 text-xl pb-4`}> </p>

        <div className={` reveal rotatee mt-6 w-full font-mono font-bold   shadow-lg  rounded-2xl ${theme === 'dark' ? ' bg-gradient-to-bl from-slate-400 shadow-slate-500 to-slate-300 text-black' : 'bg-gradient-to-bl shadow-slate-400 from-slate-600 to-slate-500 text-white'}`}>
          <div className='p-3'>
            <p className=' text-md font-bold  opacity-50 text-center '> w e e k l y - t o p i c</p>
            <br></br>
            {dataRiddle}
            <br></br><br></br>
            {riddleSubmissions.map((riddles, index) => (
              <p key={index} className="bg-white p-2 mt-2 rounded-xl bg-opacity-30">
                {riddles}
              </p>
            ))}
            <p className='mt-10 text-center'>NEXT WEEK TOPIC IS AVAILABLE BELOW 😋</p>

            <div className={`flex flex-row items-center justify-center  w-full rounded-lg  transition-all duration-300 ${theme === 'dark' ? "text-black" : "text-black"}  `}>
              <form onSubmit={handleRiddle} className={`p-4 mt-10 hover:shadow-xl  rounded-2xl bg-slate-100 flex-col items-center justify-center transition-all duration-300 ease-in-out ${toggleRiddle ? "h-auto" : "h-16"}  overflow-clip`}>
                <p onClick={toggleRiddleButton} className=' text-md font-extrabold  text-center text-lg'>SUBMIT FOR NEXT WEEK</p><br></br>


                {dataRiddleNextWeek}<br></br>

                <input
                  id="name"
                  rows="1"
                  onChange={handleNameChange}
                  value={name}
                  className={`w-full p-3 mt-2 placeholder:text-base text-base   bg-transparent border-b-2 border-slate-400 ${theme === 'dark' ? ' text-black' : 'text-black'}   placeholder:text-slate-400 border-0 focus:ring-0 focus:outline-none active:ring-0`}
                  placeholder="Name"
                  required
                />
                <textarea
                  id="riddle"
                  rows="2"
                  onChange={handleRiddleChange}
                  value={riddle}
                  className={`w-full p-3 mt-2  placeholder:text-base text-base bg-transparent border-b-2 border-slate-400 ${theme === 'dark' ? ' text-black' : 'text-black'}   placeholder:text-slate-400 border-0 focus:ring-0 focus:outline-none active:ring-0`}
                  placeholder="Type here. Best answers will be shown next week"
                  required
                />
                <button type="submit" className={`text-center mt-2 py-2.5 px-4 text-base sm:w-full w-full font-medium ${theme === 'dark' ? 'text-white bg-slate-800 hover:bg-slate-700' : 'text-white bg-slate-500 hover:bg-slate-600'}    rounded-2xl focus:ring-4 focus:ring-sky-200`}>
                  Send
                </button>
              </form>
            </div>
          </div>
        </div>








        <div className={` w-full  mt-8 mb-8 m-0 sm:w-full flex-col flex items-center`} >
          {/* <p className={`${theme === 'dark' ? 'text-slate-50' : 'text-black'} font-bold text-xl pb-4`}> Please give suggestions/changes in mess you want in feedback. We will try to convey them to Hostel Office. 😊😊</p> */}

          <div className={` p-4 w-full flex flex-col  items-center justify-center rounded-3xl   ${showMore ? 'bg-opacity-100 shadow-md hover:bg-opacity-100' : ' bg-opacity-70 shadow-none hover:bg-opacity-100'}  
            ${theme === 'dark' ? 'bg-gray-800' : 'bg-slate-200 hover:bg-slate-200 shadow-md'}  `}>

            <div className='flex w-full justify-center flex-row items-center' onClick={toggleMore}>
              <span className={`flex pl-2 text-lg   font-semibold ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}> Submit to JokeBox / Give Feedback </span>
            </div>
            {showMore && (
              <>
                <form onSubmit={handleJoke} className={`sm:w-2/3 w-full flex p-4 sm:m-2 mt-4 items-center justify-center ${theme === 'dark' ? '' : ' '} rounded-2xl border-spacing-4`}>
                  <div className="w-full rounded-lg ">

                    <div className={`px-2 py-2  ${theme === 'dark' ? '' : ' '} rounded-t-lg `}>
                      <p className={` text-xl text-center font-bold mb-4 ${theme === 'dark' ? 'text-white' : ''} `}>Submit to JokeBox</p>

                      <input
                        id="name"
                        rows="1"
                        onChange={handleNameChange}
                        value={name}
                        className={`w-full p-3  placeholder:text-base text-base bg-transparent border-slate-600 border-b-2 ${theme === 'dark' ? 'text-white' : 'text-black'}   placeholder:text-slate-500 border-0 focus:ring-0 focus:outline-none active:ring-0`}
                        placeholder="Name"
                        required
                      />
                      <input
                        id="joke"
                        rows="1"
                        onChange={handleJokeChange}
                        value={typejoke}
                        className={`w-full p-3 placeholder:text-base text-base  bg-transparent border-slate-600 border-b-2   ${theme === 'dark' ? 'text-white' : 'text-black'}   placeholder:text-slate-500 border-0 focus:ring-0 focus:outline-none active:ring-0`}
                        placeholder="Type and get quoted for a day of month."
                        required
                      />
                    </div>
                    <div className="flex items-end px-3 py-2 ">
                      <button type="submit" className={`text-center py-2.5 px-4 text-base sm:w-full w-full font-medium ${theme === 'dark' ? 'text-white bg-sky-900 hover:bg-sky-700' : 'text-white bg-sky-500 hover:bg-sky-600'}    rounded-2xl focus:ring-4 focus:ring-sky-200`}>
                        Send
                      </button>
                    </div>
                  </div>
                </form>
                <form onSubmit={handleSubmit} className={`sm:w-2/3 w-full flex p-4 sm:m-2 mt-4 items-center justify-center ${theme === 'dark' ? '' : ' '} rounded-2xl border-spacing-4`}>
                  <div className="w-full rounded-lg ">
                    <div className={`px-2 py-2  ${theme === 'dark' ? '' : ' '} rounded-t-lg `}>
                      <p className={` text-xl text-center font-bold mb-4 ${theme === 'dark' ? 'text-white' : ''} `}>Your valuable Feedback</p>

                      <textarea
                        id="message"
                        rows="5"
                        onChange={handleMessageChange}
                        value={message}
                        className={`w-full px-0 placeholder:text-sm text-base bg-transparent ${theme === 'dark' ? ' ' : ''} text-white border-b-2 border-slate-600  placeholder:text-slate-500 border-0 focus:ring-0 focus:outline-none active:ring-0`}
                        placeholder="Please share us your experience/suggestions. This app is live only because you use it. Your views are all that matters to us. Please also include ur contact to help us reach you. Type here...."
                        required
                      />
                    </div>
                    <div className="flex items-end px-3 py-2 ">
                      <button type="submit" className={`text-center py-2.5 px-4 text-base sm:w-min w-full font-medium ${theme === 'dark' ? 'text-white bg-sky-900 hover:bg-sky-700' : 'text-white bg-sky-500 hover:bg-sky-600'}    rounded-2xl focus:ring-4 focus:ring-sky-200`}>
                        Send
                      </button>
                    </div>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>

        <div className={` w-full p-0 sm:mt-8 mt-10 reveal ${theme === 'dark' ? 'bg-sky-800 hover:bg-sky-700' : 'bg-sky-400 hover:bg-sky-500'}   transition-all duration-200 rounded-2xl`}>
          <button className={`m-0 p-10 rounded-lg text-3xl  ${theme === 'dark' ? 'text-white' : 'text-black'}  text-left transition-all`} >
            <a href="https://drive.google.com/drive/folders/1CbQJwKgpRlPuQJtpb16Bn73QlXbSnLTA?usp=sharing">
              How to make a homescreen shortcut of this app for iOS and android?
              <p className='text-sm mt-4'>click here</p>

            </a>
          </button>
        </div>


        <div className='flex flex-row justify-between'>
          <div className={`mt-4 text-base text-left font-semibold ${theme === 'dark' ? 'text-white' : 'text-black'}`}> MESSTIME</div>
          <div className={`mt-4 text-base text-right font-semibold ${theme === 'dark' ? 'text-white' : 'text-black'}`}> - arc</div>
        </div>

      </div>
    </div>


  );
};


export default App;